const LOAD_DETAIL_TICKET           = 'LOAD_DETAIL_TICKET'
const LOAD_DETAIL_TICKET_SUCCESS   = 'LOAD_DETAIL_TICKET_SUCCESS'
const LOAD_DETAIL_TICKET_FAILED    = 'LOAD_DETAIL_TICKET_FAILED'
const UNMOUNT_DETAIL_TICKET        = 'UNMOUNT_DETAIL_TICKET'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const ticketDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_TICKET:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_TICKET_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_TICKET_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_TICKET:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default ticketDetailReducer;